<template>
  <div class="validation-icon-wrapper" :class="{ 'in-dropdown': inDropdown }">
    <svg
      v-if="isValid && isTouched"
      class="icon-success"
      viewBox="0 0 24 24"
      fill="none"
      stroke="currentColor"
      stroke-width="2"
      stroke-linecap="round"
      stroke-linejoin="round">
      <polyline points="20 6 9 17 4 12"></polyline>
    </svg>
  </div>
</template>

<script setup lang="ts">
defineProps<{
  isValid: boolean;
  isTouched: boolean;
  inDropdown?: boolean;
  errorMessage?: string;
}>();
</script>
